import React from 'react';
import { ExceptionAction, ExceptionReference } from '@/redux/slices/slice_types';
import { getActionButtonLabel } from '@/components/Exceptions/utils/utils';
import { Link } from '@mui/material';
import { NavLink } from 'react-router-dom';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import PolarisIcon from '@/components/_common/PolarisIcon';

interface Props {
  action: ExceptionAction;
  references: ExceptionReference[];
}

const OverflowMenuLinkActionButton: React.FC<Props> = ({ action, references }) => {
  const label = getActionButtonLabel(action, references);

  return (
    <Link
      component={NavLink}
      to={action.detail.url}
      target="_blank"
      sx={(theme) => ({
        color: theme.palette.text.primary
      })}
      onClick={(e) => e.stopPropagation()}
    >
      <OverflowMenuItem>
        <PolarisIcon icon="link" height={18} /> {label}
      </OverflowMenuItem>
    </Link>
  );
};

export default OverflowMenuLinkActionButton;
